import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const get = async () => {
  return await axiosIns.get(obtenerUrl('transacciones'));
};

const store = async (data) => {
  return await axiosIns.post(obtenerUrl('transacciones'), data);
};

const update = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`transacciones/${id}`), data);
};

const destroy = async (id) => {
  return await axiosIns.delete(obtenerUrl(`transacciones/${id}`));
};

const revisar = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`transacciones/${id}/revisar`), data);
};

export default {
  get,
  store,
  update,
  destroy,
  revisar,
};
